import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=4850c156&"
import script from "./Text.vue?vue&type=script&lang=js&"
export * from "./Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4850c156')) {
      api.createRecord('4850c156', component.options)
    } else {
      api.reload('4850c156', component.options)
    }
    module.hot.accept("./Text.vue?vue&type=template&id=4850c156&", function () {
      api.rerender('4850c156', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Common/Forms/Text.vue"
export default component.exports